import React, { useEffect } from "react";
import Container from "react-bootstrap/Container";
import Table from "react-bootstrap/Table";
import Layout from "../Components/Layout/Layout";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { startstopLoading } from "../Redux/Reducers/globalSlice";
import { deleteLocation, editLocation } from "../Redux/Actions/songs";
import NoData from "../Components/NoData";
import { capitalize } from "../Utils/commonFiles";
import DeleteModal from "../Components/CommanModals/DeleteModal";
import { toast } from "react-toastify";
import CreateReferrals from "../Components/CommanModals/CreateReferrals";
import { deleteReferral, editReferrals, getReferralsLists } from "../Redux/Actions/auth";

export default function ReferralSource() {
    const dispatch = useDispatch()
    const [showModal, setShowModal] = useState(false);
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [referralToDelete, setReferralToDelete] = useState(null);
    const [ischeckToggle, setIsCheckToggle] = useState({})

    const referralLists = useSelector((e) => e.userAuth.getReferralsData);

    const handleShow = () => setShowModal(true);
    const handleClose = () => {
        setShowModal(false);
        setSelectedLocation(null)
    }

    const handleOpenDeleteModal = (id) => {
        setReferralToDelete(id);
        setShowDeleteModal(true);
    };

    const handleCloseDeleteModal = () => setShowDeleteModal(false);

    const handleDeleteSong = () => {
        dispatch(deleteReferral({ id: referralToDelete })).then((res) => {
            if (res?.payload?.statusCode == 200) {
                Initialize()
                toast.success("Deleted Successfully")
            } else {
                toast.error(res?.payload?.message)
            }
            handleCloseDeleteModal();
        })
    }

    useEffect(() => {
        if (referralLists?.length > 0) {
            setIsCheckToggle(
                referralLists.reduce((acc, item) => {
                    acc[item._id] = item.hasOwnProperty("active") ? item.active : true;
                    return acc;
                }, {})
            );
        }
    }, [referralLists]);


    const handleChange = async (values) => {
        let data = {
            id: values._id,
            active: !values.active,
        };

        setIsCheckToggle((prevState) => ({
            ...prevState,
            [values._id]: !prevState[values._id],
        }));
        try {
            await dispatch(editReferrals(data)).then((res) => {
                if (res?.payload?.statusCode == 200) {
                    Initialize()
                }
            })
        } catch (error) {
        }
    }

    const Initialize = () => {
        dispatch(startstopLoading(true));
        dispatch(getReferralsLists()).then((res) => {
            dispatch(startstopLoading(false));
        });
    }

    useEffect(() => {
        Initialize()
    }, [dispatch]);

    return (
        <Layout>
            <Container fluid>
                <div className="comn-table-title">
                    <h3>
                        Referrals <span>({referralLists?.length ?? "0"})</span>
                    </h3>
                    <button onClick={handleShow}>Add Referrals</button>
                </div>
                <div className="filters">
                    <div className="inner-filter-field">
                        <div class="table-responsive">
                            <Table size="sm" className="table-cmn">
                                <thead>
                                    <tr>
                                        <th>
                                            <div className="user-checkbox">Referral Name</div>
                                        </th>
                                        <th>Selection</th>
                                        <th>Visible</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>

                                    {referralLists?.length > 0 && referralLists?.map((item, i) => (
                                        <tr key={i}>
                                            <td>
                                                <div className="first-user">
                                                    <div className="user-profile">
                                                        {capitalize(item?.name)}
                                                        {item?.cityName ? ` - ${capitalize(item.cityName)}` : ''}
                                                    </div>

                                                </div>
                                            </td>
                                     <td>{item?.selected ? `${item.selected} times` : "-"}</td>
                                            <td>
                                                <label className="switch">
                                                    <input
                                                        type="checkbox"
                                                        checked={ischeckToggle[item?._id] === true}
                                                        onChange={() => handleChange(item)}
                                                    />
                                                    <span className="slider round"></span>
                                                </label>
                                            </td>

                                            <td>
                                                <div className="d-flex gap-2">
                                                    <div className="td-txt-bg" onClick={() => {
                                                        handleOpenDeleteModal(item._id)
                                                    }} style={{ cursor: "pointer" }}>Delete</div>
                                                </div>
                                            </td>
                                        </tr>

                                    ))}

                                </tbody>
                            </Table>
                        </div>
                    </div>
                </div>
                <div className="mb-0">
                    <p className="pb-4"></p>
                </div>
            </Container>

            <CreateReferrals show={showModal} handleClose={handleClose} selectedLocation={selectedLocation} Initialize={Initialize} />

            <DeleteModal
                show={showDeleteModal}
                handleClose={handleCloseDeleteModal}
                handleDelete={handleDeleteSong}
                name={"Referral"}
            />
        </Layout>
    );
}
